import { LgTranslateService } from "@logex/framework/lg-localization";
import { IDropdownDefinition } from "@logex/framework/ui-core";
import { NameId } from "@mrdm-self-service-frontend/shared/types";

export function setEnumDropdown(
    enumSource: {
        [n: number]: string;
    },
    lcPrefix: string,
    translationService: LgTranslateService
): IDropdownDefinition<number> {
    const entries = [];

    for (const item in enumSource) {
        if (isNaN(Number(item))) {
            entries.push({
                id: enumSource[item],
                name: translationService.translate(lcPrefix + enumSource[item]),
            });
        }
    }

    return {
        groups: [
            {
                entries,
            },
        ],
    };
}

export function getEnumOptions(
    enumSource: {
        [n: number]: string;
    },
    lcPrefix: string,
    translationService: LgTranslateService
): NameId[] {
    const entries: NameId[] = [];

    for (const item in enumSource) {
        if (isNaN(Number(item))) {
            entries.push({
                id: Number(enumSource[item]),
                name: translationService.translate(lcPrefix + enumSource[item]),
            });
        }
    }

    return entries;
}
